export const _en = {
    name: {
        label: "Name"
    },
    trainingProduct: {
        label: "Training product"
    },
    state: {
        label: "State"
    },
    startDate: {
        label: "Start date"
    },
    finishDate: {
        label: "Finish date"
    },
    beginHour: {
        label: "Beginning hour"
    },
    moduleDuration: {
        label: "Module duration"
    },
    season: {
        label: "Season"
    },
    automatized: {
        label: "Is automatized ?"
    },
    lastModifier: {
        label: "Last modified by"
    },
    lastModifiedDate: {
        label: "Last date modified"
    },
    availabilityId: {
        label: "Availabilities time"
    },
    refSiteId: {
        label: "Site"
    },
    refTrainingProductPrefixId: {
        ALL: {
            label: "Prefix / Code"
        },
        AFCA: {
            label: "Prefix"
        },
        ATO: {
            label: "Code"
        }
    },
    organization: {
        label: "Organization"
    },
    color: {
        label: "Color"
    },
    duration: {
        label: "Theoretical duration"
    },
    trainingCourseNumber: {
        label: "Number of stage"
    },
    refPlaneTypeId: {
        label: "Plane type"
    },
    familie: {
        label: "Family"
    },
    filtersTitle: {
        label: "Filters"
    },
    DateIntervalSelectionTitle: {
        label: "Interval"
    },
    maxTrainee: {
        label: "Max trainee "
    },
    defaultBreakTimeBefore: {
        label: "Default break time before"
    },
    defaultBreakTimeAfter: {
        label: "Default break time after"
    },
    crewType: {
        label: "Crew type"
    },
    courseType: {
        label: "Type"
    },
    rubric: {
        label: "Category"
    },
    PAI: {
        label: "PAI"
    },
    LMC: {
        label: "LMC",
        tooltip: "Long and Medium Haul"
    },
    refDivisionId: {
        label: "Division"
    },
    regulatoryDuration: {
        label: "Legal maximum duration"
    },
    category: {
        trainee: { label: "Planning and trainees" },
        global: { label: "Course information" },
        other: { label: "Other" },
        update: { label: "Update" }
    },
    finishDateRegulatory: {
        label: "End date regulatory"
    },
    finishDateEffective: {
        label: "End date effective"
    }
};

export const _fr = {
    name: {
        label: "Nom du stage"
    },
    trainingProduct: {
        label: "Modèle de stage"
    },
    state: {
        label: "Statut"
    },
    availabilityId: {
        label: "Calendrier de planification"
    },
    startDate: {
        label: "Date de début"
    },
    finishDate: {
        label: "Date de fin théorique"
    },
    beginHour: {
        label: "Heure de début"
    },
    moduleDuration: {
        label: "Durée du module"
    },
    season: {
        label: "Saison"
    },
    automatized: {
        label: "Numérotation automatique"
    },
    lastModifier: {
        label: "Dernier modificateur"
    },
    lastModifiedDate: {
        label: "Dernière modification"
    },
    refTrainingProductPrefixId: {
        ALL: {
            label: "Préfixe / Code"
        },
        AFCA: {
            label: "Préfixe stage"
        },
        ATO: {
            label: "Code stage"
        }
    },
    organization: {
        label: "Compagnie"
    },
    color: {
        label: "Couleur associée"
    },
    duration: {
        label: "Durée théorique"
    },
    trainingCourseNumber: {
        label: "Numéro de stage"
    },
    refPlaneTypeId: {
        label: "Type avion"
    },
    familie: {
        label: "Famille"
    },
    refSiteId: {
        label: "Site"
    },
    filtersTitle: {
        label: "Filtres"
    },
    DateIntervalSelectionTitle: {
        label: "Période de validité"
    },
    maxTrainee: {
        label: "Nombre de stagiaires"
    },
    defaultBreakTimeBefore: {
        label: "Temps de pause par défaut avant une activité"
    },
    defaultBreakTimeAfter: {
        label: "Temps de pause par défaut après une activité"
    },
    crewType: {
        label: "Type d'équipage"
    },
    courseType: {
        label: "Type"
    },
    rubric: {
        label: "Rubrique"
    },
    PAI: {
        label: "PAI"
    },
    LMC: {
        label: "LMC",
        tooltip: "Long et Moyen Courrier"

    },
    refDivisionId: {
        label: "Service"
    },
    regulatoryDuration: {
        label: "Durée règlementaire maximale"
    },
    category: {
        trainee: { label: "Planification et stagiaires" },
        global: { label: "Informations générales" },
        other: { label: "Informations complémentaires" },
        update: { label: "Mise à jour" }
    },
    finishDateRegulatory: {
        label: "Date de fin règlementaire"
    },
    finishDateEffective: {
        label: "Date de fin effective"
    }
};